import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneRequestPayload } from '@app-store/slices/editList/one'

interface TaskAction extends Action {
    payload: IOneRequestPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.editList.one

function* oneSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/edit-lists/one/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneSagaTask)
}

export default oneSaga
